import {
  TOKENFCM_ERROR,
  TOKENFCM_LOADING,
  TOKENFCM_SUCCESS,
  TOKENFCM_RESET,
  SET_NEW_TOKENFCM,
} from "../../ActionTypes";
import axiosInstance from "../../../../global/helpers/axiosInstance";

export const wsPostTokenFCM = (dtoTokenFCM) => (dispatch) => {
  dispatch({
    type: TOKENFCM_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post(`paciente/idApp`, dtoTokenFCM)
      .then((res) => {
        dispatch({
          type: TOKENFCM_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: TOKENFCM_ERROR,
          payload: error,
        });
      });
  });
};

export const tokenFCMReset = () => (dispatch) => {
  dispatch({
    type: TOKENFCM_RESET,
  });
};
export const setNewtokenFCM = (token) => (dispatch) => {
  dispatch({
    type: SET_NEW_TOKENFCM,
    payload: token,
  });
};
